import React, { useCallback, useMemo } from 'react';
import { IconMenuFoldOutline, IconMenuUnfoldOutline } from '@baidu/lsqm-icon';
import { Menu, Layout } from '@osui/ui';
import { IconDownOutlined } from '@osui/icons-icloud';
import { useDerivedState } from 'huse';
import { Link, useLocation, matchPath } from 'react-router-dom';
import classNames from 'classnames';
import './Sider.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const {
  SubMenu
} = Menu;
const {
  Sider: OSUISider
} = Layout;

/** 侧边栏宽度 */
export const siderWidth = 180;

const getOpenKeys = item => {
  if (item.children) {
    return [item.key, ...item.children.reduce((total, current) => [...total, ...getOpenKeys(current)], [])];
  }

  return [];
};

function Sider(props) {
  const {
    icon,
    title,
    menus,
    fixed = true,
    collapsible = false,
    shadow = true,
    defaultCollapsed = false,
    className,
    style,
    onCollapse: onCollapseIn,
    ...restProps
  } = props;
  const {
    pathname
  } = useLocation();
  const [collapsed, toggle] = useDerivedState('collapsed' in props ? props.collapsed : defaultCollapsed);
  const onCollapse = useCallback((...arr) => {
    toggle(...arr);
    onCollapseIn && onCollapseIn(...arr);
  }, [onCollapseIn, toggle]);
  const selectedKeys = useMemo(() => {
    var _menu$key;

    if (restProps.selectedKeys) {
      return restProps.selectedKeys;
    }

    function findMatchedMenu(menus) {
      for (const menu of menus) {
        const confPathname = menu.key.split('?')[0];

        if (matchPath(pathname, {
          path: confPathname
        })) {
          return menu;
        }

        if (menu.children) {
          const result = findMatchedMenu(menu.children);

          if (result) {
            return result;
          }
        }
      }
    }

    const menu = findMatchedMenu(menus);
    const selectedKey = (_menu$key = menu === null || menu === void 0 ? void 0 : menu.key) !== null && _menu$key !== void 0 ? _menu$key : pathname;
    return [selectedKey];
  }, [menus, pathname, restProps.selectedKeys]);
  const renderMenuItem = useCallback(({
    children,
    key,
    ...restProps
  }) => {
    if (children) {
      return /*#__PURE__*/_jsx(SubMenu, { ...restProps,
        children: children.map(renderMenuItem)
      }, key);
    }

    const content = /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx("span", {
        children: restProps.title
      })
    });

    return /*#__PURE__*/_jsx(Menu.Item, { ...restProps,
      children: restProps.onClick == null ? /*#__PURE__*/_jsx(Link, {
        to: key,
        children: content
      }) : content
    }, key);
  }, []);
  const defaultOpenKeys = useMemo(() => {
    if ('defaultOpenKeys' in restProps) {
      return restProps.defaultOpenKeys;
    }

    return menus.reduce((total, current) => {
      return [...total, ...getOpenKeys(current)];
    }, []);
  }, [restProps, menus]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(OSUISider, {
      theme: "light",
      width: siderWidth,
      collapsed: collapsed,
      collapsedWidth: 50,
      collapsible: collapsible,
      onCollapse: onCollapse,
      trigger: collapsed ? /*#__PURE__*/_jsx(IconMenuUnfoldOutline, {}) : /*#__PURE__*/_jsx(IconMenuFoldOutline, {}),
      className: classNames('icloud-ui-page-layout-sider', {
        'icloud-ui-page-layout-sider-fixed': fixed
      }, {
        'icloud-ui-page-layout-sider-shadow': shadow
      }, className),
      style: style,
      children: [(icon || title !== undefined) && /*#__PURE__*/_jsxs("div", {
        className: "icloud-ui-page-layout-sider-header",
        children: [icon && /*#__PURE__*/_jsx("div", {
          className: "icloud-ui-page-layout-sider-header-icon",
          children: icon
        }), /*#__PURE__*/_jsx("h1", {
          className: "icloud-ui-page-layout-sider-header-title",
          children: title
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "icloud-ui-page-layout-sider-menus",
        children: /*#__PURE__*/_jsx(Menu, {
          expandIcon: collapsed ? /*#__PURE__*/_jsx(_Fragment, {}) : /*#__PURE__*/_jsx(IconDownOutlined, {}),
          inlineIndent: collapsed ? 0 : 15,
          mode: "inline",
          defaultOpenKeys: defaultOpenKeys,
          selectedKeys: selectedKeys,
          ...restProps,
          children: menus.map(renderMenuItem)
        })
      })]
    }), fixed && /*#__PURE__*/_jsx("div", {
      className: classNames('icloud-ui-page-layout-sider-placeholder', {
        'icloud-ui-page-layout-sider-placeholder-collapsed': collapsed
      })
    })]
  });
}

Sider.displayName = "Sider";
export default Sider;
//# sourceMappingURL=es/Sider.js.map